import { createSlice } from '@reduxjs/toolkit'

import { Location } from 'appTypes/shop'

import { isPendingShopAction, isRejectedShopAction } from './shopHelpers'
import { getLocations } from './shopThunks'

export interface InitialState {
  locations: Location[]
  isLoading: boolean
}

const initialState: InitialState = {
  locations: [],
  isLoading: false,
}

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLocations.fulfilled, (state, { payload }) => {
      state.locations = payload.map((loc) => ({ ...loc, value: loc.id, subLabel: loc.address }))
      state.isLoading = false
    })

    builder.addMatcher(isPendingShopAction, (state) => {
      state.isLoading = true
    })

    builder.addMatcher(isRejectedShopAction, (state) => {
      state.isLoading = false
    })
  },
})

export default shopSlice.reducer

export * from './shopThunks'
